import React, { useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AppContext } from "../../contexts/AppContext";
import "./Header.css";
import logo from "../../wemex_product_MedicomShinsatsusupport.svg";
import Dialog from "../Dialog/Dialog";

function Header() {
  const navigate = useNavigate();
  const { globalLoginUserInfo, setGlobalLoginUserInfo } =
    useContext(AppContext);

  const location = useLocation(); // 現在のURLを取得

  const isOnMyPage = location.pathname.startsWith("/mypage");
  const [isNavDialogOpen, setNavDialogOpen] = useState(false);

  const handleMypageClick = () => {
    // マイページ画面に遷移
    navigate(`/mypage/menu`);
  };

  const handleLogoutClick = () => {
    // 確認ダイアログを表示
    setNavDialogOpen(true);
  };

  // 選択肢
  const navButtons = [
    {
      label: "はい",
      width: "140px",
      type: "primary-blue",
      onClick: () => handleNavDialogClose(true),
    },
    {
      label: "いいえ",
      width: "140px",
      type: "secondary-white",
      onClick: () => handleNavDialogClose(false),
    },
  ];

  /**
   * ナビゲーションの確認ダイアログのボタンがクリックされたときの処理
   * @param {number} buttonIndex - クリックされたボタンのインデックス
   */
  const handleNavDialogClose = (buttonIndex) => {
    setNavDialogOpen(false);
    if (buttonIndex) {
      setGlobalLoginUserInfo(null);
      navigate("/mypage/account-login");
    }
  };

  return (
    <div className="header">
      <img src={logo} alt="Logo" />
      <div className="link-area">
        {!isOnMyPage && globalLoginUserInfo && (
          <div className="link mypage-text" onClick={handleMypageClick}>
            マイページ
          </div>
        )}
        {isOnMyPage && globalLoginUserInfo && (
          <div className="link logout-text" onClick={handleLogoutClick}>
            ログアウト
          </div>
        )}
      </div>
      <Dialog
        title="確認"
        isOpen={isNavDialogOpen}
        onClose={() => setNavDialogOpen(false)}
        buttons={navButtons}
      >
        <div className="dialog-normal-area">
          {"ログアウトします。よろしいですか？"}
        </div>
      </Dialog>
    </div>
  );
}

export default Header;
